import $ from 'jquery';
import { toggleCartDrawer } from '../utils/slideDrawer.js';
jQuery.noConflict();

// Hide Search when in the checkout
export function hideSearch() {
    if (window.location.href.indexOf("checkout/onepage/") > -1) {
        $('.top-search').css('visibility', 'hidden');
        $('.scroll-search-button').css('visibility', 'hidden');
        $('.block-cart .block-subtitle').hide();
        $('button.button.btn-sidebar-cart').hide();
        $('.login-icon-wrapper').hide();
        $('.block-cart .actions').css('text-align', 'center');
        $('button.button.btn-edit-cart').css('margin-top', '15px').css('float', 'none').css('width', '200px');
        $('#cart-sidebar').replaceWith($('#modal-cart-data'));
        
        // Handle cart drawer triggers (Review Cart, Review All links)
        // Use event delegation since elements may be added dynamically
        $(document).on('click', '.cart-drawer-trigger', function (event) {
            event.preventDefault();
            
            // Check if drawer is currently closed
            const isClosed = !$('span.cart.sidebar').hasClass('selected');
            
            if (isClosed) {
                // Only open the drawer, don't toggle
                $('span.login.account > a').removeClass('selected');
                toggleCartDrawer();
                
                $('.pulldown').hide();
                $('.scroll-search-container').hide();
                $('.rootmenu-mobile').removeClass('open');
                $('.wrapper-overlay').hide();
                $('.header.is-mobile').next().addClass('hidden');
                $('.wrapper-overlay-dark').show();
            }
            
            event.stopPropagation();
            return false;
        });
        
        $('span.cart.sidebar strong span.text').before('<span class="cart-icon-arrow"><i class="fa fa-chevron-down"><i></span>');
    }
}